# 부품검사 현황
<template>
	<sf-content-layout>
		<template v-slot:location>
			<sf-location :locations="locations" />
		</template>
		<template v-slot:title>
			<sf-content-title :title="getMessage_(screen.menuTitle)" useFavorite :favorite="screen.favoriteYn === 'Y'" :onFavorite="onFavorite" />
		</template>
		<template v-slot:button>
			<sf-button size="lg" color="default" :line="false" className="sf-button--black-light" :action="Save">Save</sf-button>
		</template>
		<template v-slot:content>
			<content-view ref="content" :scrId="scrId"></content-view>
		</template>
	</sf-content-layout>
</template>

<script>
import { rootComputed, rootMethods } from '@/store/common/helpers';
import { serviceMethods, serviceComputed } from './store/helpers';
import ContentView from './Content/Content.vue';

export default {
	props: {
		scrId: { type: String, default: '' }
	},
	data() {
		return {
			screen: {}
		};
	},
	created() {
		console.clear();
		this.setStateInit_();
		this.screen = this.screenArray.get(this.scrId);
	},
	components: {
		ContentView
	},
	computed: {
		...rootComputed,
		...serviceComputed,
		locations() {
			if (this.screen?.menuLocation) {
				return this.screen.menuLocation.map(str => this.getMessage_(str));
			}
			return [];
		}
	},
	methods: {
		...rootMethods,
		...serviceMethods,
		async onFavorite() {
			try {
				this.$sf_toggleLoading(true);
				const header = await this.onFavorite_();
				this.$sf_showMessage({
					...this.$sf_setMessageOption(header),
					message: this.getMessage_(header.messageCd) || header.message
				});
			} catch (error) {
				this.$sf_showMessage({ title: 'Error', icon: 'error', message: error.message });
			} finally {
				this.$sf_toggleLoading(false);
			}
		}
	}
};
</script>

<style></style>
